/**
 * Roles API endpoints
 */
import type { ApiResponse, ApiListResponse } from "../lib/types";
import { authenticatedRequest } from "../lib/api";

export interface Role {
 id: string;
 name: string;
 companyId: string;
 companyName?: string;
 userCount?: number;
 isActive: boolean;
 createdAt: string;
 updatedAt: string;
}

export interface RoleInput {
 name: string;
 companyId?: string;
}

export interface RoleUpdate {
 name?: string;
 companyId?: string;
 isActive?: boolean;
}

export async function getRoles(
 token: string,
 companyId?: string
): Promise<Role[]> {
 const query = companyId ? `?companyId=${companyId}` : "";
 return authenticatedRequest<ApiListResponse<Role>>(
  `/api/roles${query}`,
  token
 ).then((res) => res.data);
}

export async function getRole(
 token: string,
 id: string,
 companyId?: string
): Promise<Role> {
 const query = companyId ? `?companyId=${companyId}` : "";
 return authenticatedRequest<ApiResponse<Role>>(
  `/api/roles/${id}${query}`,
  token
 ).then((res) => res.data);
}

export async function createRole(
 token: string,
 input: RoleInput
): Promise<Role> {
 return authenticatedRequest<ApiResponse<Role>>("/api/roles", token, {
  method: "POST",
  body: JSON.stringify(input),
 }).then((res) => res.data);
}

export async function updateRole(
 token: string,
 id: string,
 input: RoleUpdate,
 companyId?: string
): Promise<Role> {
 const query = companyId ? `?companyId=${companyId}` : "";
 return authenticatedRequest<ApiResponse<Role>>(
  `/api/roles/${id}${query}`,
  token,
  {
   method: "PUT",
   body: JSON.stringify(input),
  }
 ).then((res) => res.data);
}

export async function deleteRole(
 token: string,
 id: string,
 companyId?: string
): Promise<void> {
 const query = companyId ? `?companyId=${companyId}` : "";
 return authenticatedRequest(`/api/roles/${id}${query}`, token, {
  method: "DELETE",
 }).then(() => undefined);
}
